import { Button, TModalCustomView } from '@ws/shared/components';

import styles from './InfoModal.module.css';

export function getInfoModal({
  onFloatingWindowTry,
  onSplitModeTry,
}: {
  onSplitModeTry: () => void;
  onFloatingWindowTry: () => void;
}): TModalCustomView {
  return function InfoModal({
    closeAllModals,
    onAwayClose,
    components: { ModalWrapper, ModalContentWrapper, ModalCloseButton, ModalTitle, ModalContent },
  }) {
    return (
      <ModalWrapper onClick={onAwayClose}>
        <ModalContentWrapper>
          <ModalCloseButton onClose={closeAllModals} />
          <ModalTitle>Tricks & Tips</ModalTitle>
          <ModalContent>
            <div style={{ overflow: 'auto', maxHeight: '80vh' }}>
              <h3>Идея редактора:</h3>
              <p>
                В боковой панели слева коллекция (она же папка) с названием проекта считается
                Корневой. Коллекцию &quot;Черновики&quot; можно считать вспомогательной, для
                хранения дополнительных заметок. Структура коллекций и заметок древовидна и
                позволяет любую вложенность.
              </p>
              <p>
                В основной коллекции располагаются все узлы (коллекции и заметки), которые будут
                участвовать в составлении основного полотна текста. Это значит, что всё содержимое
                коллекции &quot;Черновики&quot; никогда не будет отображено в режиме Ленты Корневой
                коллекции.
              </p>
              <p>
                Режим Ленты — это просмотр видимой части проекта относительно выбранной коллекции.
                При переходе в режим Ленты всё содержимое выбранной коллекции отображается на экране
                одновременно, сохраняя порядок и структуру установленную в дереве.
              </p>
              <p>
                Каждый узел дерева может быть скрыт. Тогда он не будет отображаться в режиме Ленты.
                Переключатель видимости узла возникает, если на узел навести курсор мыши.
              </p>

              <h3>Полезные советы и горячие клавиши:</h3>
              <div className={styles['tip-card']}>
                <h4>Режим Ленты</h4>
                <p>
                  По клику на текст заметки появляется кнопка редактирования, при нажатии на которую
                  заметка переходит в режим редактирования. У каждой заметки отображается название,
                  при клике на которое можно перейти в саму заметке.
                </p>
              </div>

              <div className={styles['tip-card']}>
                <h4>Открытие в режиме Разделенного экрана</h4>
                <div className={styles['shortcut-container']}>
                  <kbd>
                    <code>Ctrl</code>/<code>Cmd</code> + клик
                  </kbd>{' '}
                  по любой узел
                </div>
                <p className={styles['tip-note']}>
                  Позволяет одновременно открывать два узла (заметку или коллекцию) на одном экране.
                  Функция доступна только в десктопной версии приложения.
                </p>
                <Button
                  onClick={onSplitModeTry}
                  className={styles['action-btn']}
                  variant="shapeless"
                >
                  Попробовать
                </Button>
              </div>

              <div className={styles['tip-card']}>
                <h4>Плавающее окно</h4>
                <div className={styles['shortcut-container']}>
                  <kbd>
                    <code>Shift</code> + клик
                  </kbd>{' '}
                  по заметке
                </div>
                <p className={styles['tip-note']}>
                  Можно открыть до трёх окон. Окна можно сворачивать. Заголовки свёрнутых окон
                  находятся внизу экрана. Функция доступна только в десктопной версии приложения.
                </p>
                <Button
                  onClick={onFloatingWindowTry}
                  className={styles['action-btn']}
                  variant="shapeless"
                >
                  Попробовать
                </Button>
              </div>

              <div className={styles['tip-card']}>
                <h4>Экспорт в PDF или DOCX</h4>
                <ol className={styles['numbered-steps']}>
                  <li>
                    Перейдите в <strong>желаемую коллекцию</strong>
                  </li>
                  <li>Используйте кнопки экспорта в шапке страницы в меню справа</li>
                </ol>
                <p className={styles['tip-note']}>
                  Оба формата работают в любом режиме — переходить в Ленту не нужно.
                </p>
                <p className={styles['tip-note']}>
                  Экспортируются только данные выбранной коллекции
                </p>
              </div>
            </div>
          </ModalContent>
        </ModalContentWrapper>
      </ModalWrapper>
    );
  };
}
